import { FC } from 'react';
import { Tooltip } from '@mui/material';
import { RotateCcw, RotateCw } from 'react-feather';
import ButtonComponent from './common/ButtonComponent';
import SettingsWrapper from './common/SettingsWrapper';
import { useFabricEditor } from '../lib/FabricJs';
import { useHandleHistory } from '../lib/FabricJs/hooks/useHandleHistory';

const Rotate: FC = () => {
  const { canvas } = useFabricEditor();
  const { handleHistory } = useHandleHistory();

  const rotateBy = (deltaDeg: number) => {
    if (!canvas) return;
    const activeObjects = canvas.getActiveObjects();
    activeObjects.forEach((object) => {
      // Fabric objects rotate around their origin point (default: top-left
      // corner), so just changing .angle swings the object around that
      // corner and can push it off-canvas. Capture the center first and
      // reposition the object back onto it after the angle change, so it
      // rotates in place instead.
      const center = object.getCenterPoint();
      const newAngle = ((object.angle ?? 0) + deltaDeg + 360) % 360;
      object.set({ angle: newAngle });
      object.setPositionByOrigin(center, 'center', 'center');
      object.setCoords();
    });
    canvas.renderAll();
    handleHistory(canvas);
  };

  return (
    <SettingsWrapper>
      <Tooltip title="Rotate 90° counter-clockwise">
        <ButtonComponent onClick={() => rotateBy(-90)}>
          <RotateCcw size={20} />
        </ButtonComponent>
      </Tooltip>
      <Tooltip title="Rotate 90° clockwise">
        <ButtonComponent onClick={() => rotateBy(90)}>
          <RotateCw size={20} />
        </ButtonComponent>
      </Tooltip>
      <Tooltip title="Rotate 180°">
        <ButtonComponent onClick={() => rotateBy(180)}>180°</ButtonComponent>
      </Tooltip>
    </SettingsWrapper>
  );
};

export default Rotate;
